import { EllipsisSpan, Paging, Table, usePaging, useUpdate } from '@maxtropy/components';
import { Badge, Button, Divider, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ParamsProps } from './index';
import { EdgeTemplatePageTemplateRes, getEdgeTemplatePageTemplate } from '../../api/edgeTemplate';
import {
  EdgeDeviceTemplateStatus,
  EdgeDeviceTemplateStatusDisplay,
  IotProtocolType,
  IotProtocolTypeDisplay,
} from '@/shared/types';
import { PermissionsType } from '../../common/permissionsConst';

const otherColumns = [
  {
    title: '模板编号',
    dataIndex: 'serialNumber',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '模板名称',
    dataIndex: 'name',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '物联层协议',
    dataIndex: 'iotProtocol',
    ellipsis: { showTitle: true },
    render: (v: IotProtocolType) => <EllipsisSpan value={IotProtocolTypeDisplay[v]} />,
  },
  {
    title: '所属类目',
    dataIndex: 'deviceTypes',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '厂商',
    dataIndex: 'manufacturerName',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '物模型型号',
    dataIndex: 'modelNo',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },

  {
    title: '状态',
    dataIndex: 'status',
    ellipsis: { showTitle: true },
    render: (v: EdgeDeviceTemplateStatus) => (
      <Badge
        status={v === EdgeDeviceTemplateStatus.USED ? 'success' : 'error'}
        text={EdgeDeviceTemplateStatusDisplay[v]}
      />
    ),
  },
  {
    title: '已分配租户数',
    dataIndex: 'tenantCount',
    ellipsis: { showTitle: true },
    render: (v: number) => <EllipsisSpan value={v.toString()} />,
  },
];

interface TemplateListProps {
  searchParams?: ParamsProps;
  tabsKey?: string;
  permission?: string[];
}

const TemplateList: React.FC<TemplateListProps> = ({ searchParams, tabsKey, permission }) => {
  const { search } = useLocation();
  const pagingInfo = usePaging(50);
  const { pageOffset, pageSize, setTotalCount, setPageOffset } = pagingInfo;
  const [updateState, update] = useUpdate();
  const [loading, setLoading] = useState<boolean>(false);
  const [list, setList] = useState<EdgeTemplatePageTemplateRes[]>([]);

  const getList = () => {
    setLoading(true);
    getEdgeTemplatePageTemplate({ ...searchParams, page: pageOffset, size: pageSize }).then(res => {
      if (res) setTotalCount(res.total);
      setList(res.list);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (updateState) {
      getList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateState]);

  useEffect(() => {
    setPageOffset(1);
    if (pageOffset === 1) {
      update();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, setPageOffset]);

  useEffect(() => {
    update();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageOffset, pageSize]);

  const columns = [
    ...otherColumns,
    {
      title: '操作',
      fixed: 'right' as 'right',
      width: 200,
      render: (v: EdgeTemplatePageTemplateRes) => (
        <Space size={16}>
          {(permission ?? []).includes(PermissionsType.P_TENANTASSIGNEDGETEMPLATE) && (
            <Button
              style={{ paddingLeft: 0, paddingRight: 0 }}
              type="link"
              disabled={v.status !== EdgeDeviceTemplateStatus.USED}
            >
              <Link to={`/device/edge/distribution/tenant/create/${v.id}${search}`}>租户分配</Link>
            </Button>
          )}
          <Button style={{ paddingLeft: 0, paddingRight: 0 }} type="link">
            <Link to={`/device/edge/distribution/tenant/detail/${v.id}${search}`}>查看</Link>
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table sticky scroll={{ x: 1900 }} loading={loading} columns={columns} dataSource={list} />
      <Paging pagingInfo={pagingInfo} />
    </>
  );
};

export default TemplateList;
